import PropTypes from "prop-types";
import { Fragment } from "react";
import HeaderOne from "../wrappers/header/HeaderOne";
import ScrollToTop from "../components/scroll-to-top"
import Footer from "../wrappers/footer/Footer";
import NewsletterSection from "../components/newdesign/NewsletterSection";
import WhatsAppWidget from "../components/header/WhatsAppWidget";
import CartDrawer from "../components/cart-drawer/CartDrawer";
import MobileBottomNav from "../components/mobile-nav/MobileBottomNav";

const LayoutOne = ({
  children,
  headerContainerClass,
  headerTop,
  headerPaddingClass,
  headerPositionClass,
  hideFooter
}) => {
  return (
    <Fragment>
      <HeaderOne
        layout={headerContainerClass}
        top={headerTop}
        headerPaddingClass={headerPaddingClass}
        headerPositionClass={headerPositionClass}
      />
      {children}
      {/* <FooterOne
        backgroundColorClass="bg-gray"
        spaceTopClass="pt-100"
        spaceBottomClass="pb-70"
      /> */}
      <WhatsAppWidget/>
      {/* right-hand cart panel; opens itself on add-to-cart */}
      <CartDrawer/>
      {/* app-style bottom bar; phone/tablet only */}
      <MobileBottomNav/>
      {/* <NewsletterSection/> */}
      {/* Auth screens drop the footer so the card fits one screen. */}
      {hideFooter ? null : <Footer/>}
      {/* <ScrollToTop/> */}
    </Fragment>
  );
};

LayoutOne.propTypes = {
  children: PropTypes.node,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  headerTop: PropTypes.string,
  hideFooter: PropTypes.bool
};

export default LayoutOne;
